import React, { useState, Suspense } from "react";
import LoadingSpinner from "../../../../../components/loading/LoadingSpinner";
import { useTypedSelector } from "../../../../../redux/hooks";
import {
    selectCanAdminAllPublicGroups,
} from "../../../../../redux/slices";
import ModalFormContainer from "../../../../../components/forms/modalFormContainer/ModalFormContainer";
import { StyledButton } from "../../../../../components/StyledComponents";
import styles from '../styles.module.scss';
import { usePolyglot } from "../../../../../context/Polyglot";
import { useConversationContext } from "../../../../../context/ChatContext/contextConvo";
import { ConversationIcon } from "../../../../../components/sidebars/chat/Conversation/ConversationIcon";
import { useConversationName } from "../../../../../components/sidebars/chat/Conversation/ConversationRow";
import { isChannelType } from "../../../../../types";
import ConversationGroupForm from "../../../../../components/forms/ConversationGroupform";


const ChatSideBarHeader: React.FC = () => {
    const { conversation } = useConversationContext();

    const conversationName = useConversationName(conversation);

    const { t } = usePolyglot()

    const canAdminPublicGroups = useTypedSelector(selectCanAdminAllPublicGroups);

    const [showGroupEdit, setShowGroupEdit] = useState<boolean>(false);

    // let userStatus: { connected: boolean; last_seen: number; status?: string } | undefined;

    // if (chat?.type === 'user') {
    //     const chatUser = useTypedSelector(state => selectAuthUserByUuid(state, chat.uuid))?.name;
    //     userStatus = chatUser ? useTypedSelector(state => selectUserStatus(state, chatUser))?.chat : undefined;
    // }

    return (
        <div className={styles.chat_sidebar_data}>
            <div className={styles.icon_container}>
                <ConversationIcon convo={conversation} />
            </div>
            <div className={styles.chat_sidebar_name}>
                <p>{conversationName}</p>
                {/*
                {!noPriorChatHistory && chat.type === 'user' && userStatus && (
                    <div>
                        <ChatStatus chatStatus={userStatus} />
                    </div>
                )}
                    */}
            </div>
            {isChannelType(conversation.type) && canAdminPublicGroups && (
                <StyledButton
                    size='medium'
                    buttonStyle='tertiary'
                    context='danger'
                    onClick={() => {
                        setShowGroupEdit(true)
                    }}
                >
                    {t("actions.edit")}
                </StyledButton>
            )}
            <ModalFormContainer
                showModal={showGroupEdit}
                setShowModal={(val: boolean) => setShowGroupEdit(val)}
            >
                <Suspense fallback={<LoadingSpinner color='mamba' />}>
                    {showGroupEdit ? (
                        <ConversationGroupForm
                            closeEditor={() => setShowGroupEdit(false)}
                        />
                    ) : null}
                </Suspense>
            </ModalFormContainer>
        </div>
    )
}

export default ChatSideBarHeader
